import { deleteCookie, getCookie, setCookie } from 'cookies-next/client';
import { Currency } from 'hotdesk_typescript';

export const storeGet = <T>(key: string): T | undefined => {
    try {
        let cookies = getCookie(key);
        if (!!cookies) {
            return JSON.parse(cookies);
        }
        return undefined;
    } catch (error) {
        return undefined;
    }
};

export const storeSet = (
    key: string,
    value: any,
    options?: Parameters<typeof setCookie>[2]
) => {
    setCookie(key, value, options);
};

export const storeDelete = (key: string) => {
    deleteCookie(key);
};

export const parseNumber = (value: string, locales: string) => {
    const localePattern = Intl.NumberFormat(locales).format(1.1);
    const cleanPattern = new RegExp(`[^-+0-9${localePattern.charAt(1)}]`, 'g');
    const cleaned = value.replace(cleanPattern, '');
    const normalized = cleaned.replace(localePattern.charAt(1), '.');
    return parseFloat(normalized);
};

export const slugify = (text: string): string => {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
};

export const parseData = <T>(data: T): T => JSON.parse(JSON.stringify(data));

export const deepMerge = <
    T extends Record<string, any>,
    U extends Record<string, any>
>(
    target: T,
    source: U
): T & U => {
    const result: any = { ...target };

    for (const key in source) {
        if (
            source[key] &&
            typeof source[key] === 'object' &&
            !Array.isArray(source[key])
        ) {
            result[key] = deepMerge(result[key] || {}, source[key]);
        } else {
            result[key] = source[key];
        }
    }

    return result;
};

export const currencyConvert = (
    currencyList: Currency[],
    userCurrencyCode: string,
    baseCurrencyCode: string,
    amount: number
): number => {
    if (!currencyList || currencyList.length === 0) {
        return amount;
    }
    const baseCurrency = currencyList.find(
        (currency) => currency.code === baseCurrencyCode
    );
    const userCurrency = currencyList.find(
        (currency) => currency.code === userCurrencyCode
    );
    if (!!baseCurrency?.factor && !!userCurrency?.factor) {
        return parseFloat(
            (amount * (baseCurrency.factor / userCurrency.factor)).toFixed(2)
        );
    } else {
        return amount;
    }
};
